import Api from '@/api/admin';
import { makeApiUrl } from '@/utils/url';
import AuthService from './auth_service';

export default class AdminService {
  constructor () {
    this.authService = new AuthService();
  }
  async signinAdmin () {
    try {
      await this.authService.signinWithGoogle();
      await Api.signinAdmin();
    } catch (error) {
      return Promise.reject(error);
    }
  }
  async dummySigninAdmin (email, password) {
    try {
      await this.authService.signinWithEmailAndPassword(email, password);
      await Api.signinAdmin();
    } catch (error) {
      return Promise.reject(error);
    }
  }
  async signout () {
    try {
      await Api.signoutAdmin();
      await this.authService.signout();
    } catch (error) {
      return Promise.reject(error);
    }
  }
  async openSidekiq () {
    try {
      await Api.sidekiqAuth();
      const apiUrl = makeApiUrl();
      window.open(`${apiUrl.origin}/api/sidekiq`, '_blank');
    } catch (error) {
      return Promise.reject(error);
    }
  }
}
